import Footer from '@/components/common/footer';
import Navigation from '@/components/common/navigation';
import StarryBackground from '@/components/common/starry-background';
import { type ExtLink } from '@/types';
import { Head, Link, usePage } from '@inertiajs/react';

interface PageProps {
    plans: { id: number; title: string; content: string; main_image_path: string; issued_at: string }[];
    articles: { id: number; title: string; content: string; main_image_path: string; issued_at: string }[];
    informations: { id: number; title: string; content: string; main_image_path: string; issued_at: string }[];
    minkas?: { id: number; title: string; content: string; main_image_path: string; issued_at: string }[];
    peoples?: { id: number; title: string; content: string; main_image_path: string; issued_at: string }[];
    minatos?: { id: number; title: string; content: string; main_image_path: string; issued_at: string }[];
    akatsukis?: { id: number; title: string; content: string; main_image_path: string; issued_at: string }[];
    [key: string]: unknown;
}

const extlinks: ExtLink[] = [
    { name: '鎌倉FM オフィシャルWEBサイト', url: 'https://www.kamakurafm.co.jp/', logo: 'img/logo-kamakurafm.png' },
    { name: '鎌倉の出版社 港の人WEBサイト', url: 'https://www.minatonohito.jp/', logo: 'img/logo-minatonohito.png' },
    { name: '北鎌倉のパソコン教室 未来技術工房', url: 'https://miraitech-studio.com/', logo: 'img/logo-miraitechstudio.png' },
    {
        name: '@moonlightbox.umimachi',
        url: 'https://www.instagram.com/moonlightbox.umimachi/',
        logo: 'img/instagram-icon.png',
        text: '番組 公式アカウント',
    },
];

export default function Index() {
    const { props } = usePage<PageProps>();
    //const { plans, articles, informations, peoples, minkas, minatos, akatsukis, satomayos } = props;
    const { plans, articles, informations, peoples = [], minkas = [], minatos = [], akatsukis = [] } = props;

    return (
        <>
            <Head title="トップページ" />
            <div className="app-container">
                <StarryBackground />
                <div className="content">
                    <div className="mx-auto max-w-screen md:max-w-5xl lg:max-w-6xl">
                        <div className="grid grid-cols-1 gap-2 md:grid-cols-3">
                            <div className="order-2 row-span-2 md:order-1 md:pt-12">
                                <div className="pb-4 md:me-8">
                                    <Link href={route('home')}>
                                        <img src="img/logo-vertical-white-l.png" className="mx-auto h-auto max-w-full" />
                                    </Link>
                                    <div className="pb-4 text-center text-base md:text-lg lg:text-xl">
                                        <p className="">
                                            鎌倉FM <span className="text-red-600">82.8MHz</span>
                                        </p>
                                        <p className="">毎週金曜日 夜10:10〜11:00</p>
                                    </div>
                                    <div className="py-2 text-center">
                                        <a href="https://www.jcbasimul.com/kamakurafm" target="_blank">
                                            <button className="group relative inline-flex h-[calc(48px+8px)] items-center justify-center rounded-full bg-sky-800/90 py-1 pr-6 pl-6 text-neutral-50">
                                                <span className="z-10">鎌倉FMを聴く(JCBA)</span>
                                            </button>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div className="order-1 pt-4 text-center md:order-2 md:col-span-2 md:pt-8">
                                <Navigation />
                            </div>

                            <div className="order-3 md:order-3 md:col-span-2">
                                <div className="md:px-8">
                                    <div className="rounded-lg border border-gray-700 bg-base-100 px-5 pt-4 dark:border-gray-700 dark:bg-gray-800">
                                        <time className="text-lg font-semibold text-white dark:text-white">放送予定</time>
                                        <ol className="mt-3 divide-y divide-gray-700 dark:divide-gray-700">
                                            {plans.map((plan) => (
                                                <li className="flex pt-2 pb-4" key={plan.id}>
                                                    <img className="me-3 mb-3 h-12 w-12 rounded-full sm:mb-0" src={plan.main_image_path === null ? 'img/logo-vertical-white.png' : plan.main_image_path} />
                                                    <div className="text-gray-200">
                                                        <div className="text-base">
                                                            <Link href={route('archive.detail', { type: 'plan', id: plan.id })} method="get">
                                                                {plan.title}
                                                            </Link>
                                                        </div>
                                                        <p className="mt-1 line-clamp-2 text-sm text-gray-400">{plan.content}</p>
                                                    </div>
                                                </li>
                                            ))}
                                        </ol>
                                    </div>
                                    <div className="flex justify-end pt-2">
                                        <Link href={route('archive.index', { type: 'plan' })} method="get" as="button" className="btn btn-outline btn-xs">
                                            すべてを表示
                                        </Link>
                                    </div>


                                    <div className="px-2">
                                        <p className="py-6 text-start text-lg">
                                            「ムーンライトボックス」は、鎌倉・湘南を中心とした、うみまち地域に関わりながら頑張る「うみまちPeople」一人一人の夢や人生、文化や社会活動に焦点をあて発信する、市民参加型のラジオ番組です。ここに来てあなたの夢を叶える道具箱を開けてみませんか。
                                        </p>
                                    </div>


{/*
                                    <div className="py-2 text-center">
                                        <a href="https://www.yahoo.co.jp" target="_blank">
                                            <button className="group relative inline-flex h-[calc(48px+8px)] items-center justify-center rounded-full bg-sky-800/90 py-1 pr-14 pl-6 text-neutral-50">

                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                    strokeWidth="1.5"
                                                    stroke="currentColor"
                                                    className="me-2 size-10"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="m3.75 7.5 16.5-4.125M12 6.75c-2.708 0-5.363.224-7.948.655C2.999 7.58 2.25 8.507 2.25 9.574v9.176A2.25 2.25 0 0 0 4.5 21h15a2.25 2.25 0 0 0 2.25-2.25V9.574c0-1.067-.75-1.994-1.802-2.169A48.329 48.329 0 0 0 12 6.75Zm-1.683 6.443-.005.005-.006-.005.006-.005.005.005Zm-.005 2.127-.005-.006.005-.005.005.005-.005.005Zm-2.116-.006-.005.006-.006-.006.005-.005.006.005Zm-.005-2.116-.006-.005.006-.005.005.005-.005.005ZM9.255 10.5v.008h-.008V10.5h.008Zm3.249 1.88-.007.004-.003-.007.006-.003.004.006Zm-1.38 5.126-.003-.006.006-.004.004.007-.006.003Zm.007-6.501-.003.006-.007-.003.004-.007.006.004Zm1.37 5.129-.007-.004.004-.006.006.003-.004.007Zm.504-1.877h-.008v-.007h.008v.007ZM9.255 18v.008h-.008V18h.008Zm-3.246-1.87-.007.004L6 16.127l.006-.003.004.006Zm1.366-5.119-.004-.006.006-.004.004.007-.006.003ZM7.38 17.5l-.003.006-.007-.003.004-.007.006.004Zm-1.376-5.116L6 12.38l.003-.007.007.004-.004.007Zm-.5 1.873h-.008v-.007h.008v.007ZM17.25 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Zm0 4.5a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
                                                    />
                                                </svg>

                                                <span className="z-10 pr-2 text-xl">サンプルが試聴できます</span>
                                                <div className="absolute right-1 inline-flex h-12 w-12 items-center justify-end rounded-full bg-sky-600/90 transition-[width] group-hover:w-[calc(100%-8px)]">
                                                    <div className="mr-3.5 flex items-center justify-center">
                                                        <svg className="size-[1.2em]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                            <g
                                                                strokeLinejoin="round"
                                                                strokeLinecap="round"
                                                                strokeWidth="2"
                                                                fill="none"
                                                                stroke="currentColor"
                                                            >
                                                                <path d="M6 3L20 12 6 21 6 3z"></path>
                                                            </g>
                                                        </svg>
                                                    </div>
                                                </div>
                                            </button>
                                        </a>
                                    </div>
*/}


                                </div>
                            </div>
                        </div>

                        <div className="overflow-x-auto pb-8">
                            <h3 className="py-4 text-2xl md:text-xl font-bold text-center md:text-left">うみまち通信</h3>

                            <div className="carousel carousel-center rounded-box mb-4 max-w-full space-x-2 p-1">
                                {articles.map((article) => (
                                    <div className="carousel-item" key={article.id}>
                                        <Link
                                            href={route('archive.detail', { type: 'article', id: article.id })}
                                            method="get"
                                            className="block h-full"
                                        >
                                            <div className="card border border-gray-700 bg-base-100 flex h-full w-3xs flex-col shadow-md">
                                                <figure className="relative h-36 w-full overflow-hidden">
                                                    <img
                                                        src={article.main_image_path === null ? 'img/logo-vertical-white.png' : article.main_image_path}
                                                        alt={article.title || '記事画像'}
                                                        className="absolute inset-0 h-full w-full object-cover"
                                                    />
                                                </figure>
                                                <div className="card-body flex flex-grow flex-col px-4 py-2">
                                                    <h2 className="card-title line-clamp-3 text-base">{article.title}</h2>
                                                    <p className="mt-1 line-clamp-2 text-sm text-gray-400">{article.content}</p>
                                                    <div className="card-actions mt-auto justify-end">
                                                        <div className="badge">{article.issued_at}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                ))}
                            </div>

                            <div className="flex justify-end">
                                <Link href={route('archive.index', { type: 'article' })} method="get" as="button" className="btn btn-outline btn-xs">
                                    すべてを表示
                                </Link>
                            </div>
                        </div>

                        <div className="overflow-x-auto pb-8">
                            <h3 className="py-4 text-2xl md:text-xl font-bold text-center md:text-left">うみまちインフォメーション</h3>

                            <div className="carousel carousel-center rounded-box mb-4 max-w-full space-x-2 p-1">
                                {informations.map((information) => (
                                    <div className="carousel-item" key={information.id}>
                                        <Link
                                            href={route('archive.detail', { type: 'information', id: information.id })}
                                            method="get"
                                            className="block h-full"
                                        >
                                            <div className="card border border-gray-700 bg-base-100 flex h-full w-48 flex-col shadow-md">
                                                <figure className="relative h-36 w-full overflow-hidden">
                                                    <img src={information.main_image_path === null ? 'img/logo-vertical-white.png' : information.main_image_path} alt={information.title} />
                                                </figure>
                                                <div className="card-body flex flex-grow flex-col px-4 py-2">
                                                    <h2 className="card-title line-clamp-3 text-base">{information.title}</h2>
                                                    <div className="card-actions justify-end">
                                                        <div className="badge">{information.issued_at}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                ))}
                            </div>

                            <div className="flex justify-end">
                                <Link
                                    href={route('archive.index', { type: 'information' })}
                                    method="get"
                                    as="button"
                                    className="btn btn-outline btn-xs"
                                >
                                    すべてを表示
                                </Link>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-2">
                            <div className="">
                                <h3 className="py-4 text-2xl md:text-xl font-bold text-center md:text-left">ラジオアーカイブ
                                </h3>

                                {peoples.length > 0 && (
                                    <>
                                        <ul className="list border border-gray-700 bg-base-100 rounded-box mb-4 shadow-md">
                                            <li className="flex p-4 pb-1 text-base font-bold tracking-wide">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                    strokeWidth="1.5"
                                                    stroke="currentColor"
                                                    className="me-2 size-7"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="m3.75 7.5 16.5-4.125M12 6.75c-2.708 0-5.363.224-7.948.655C2.999 7.58 2.25 8.507 2.25 9.574v9.176A2.25 2.25 0 0 0 4.5 21h15a2.25 2.25 0 0 0 2.25-2.25V9.574c0-1.067-.75-1.994-1.802-2.169A48.329 48.329 0 0 0 12 6.75Zm-1.683 6.443-.005.005-.006-.005.006-.005.005.005Zm-.005 2.127-.005-.006.005-.005.005.005-.005.005Zm-2.116-.006-.005.006-.006-.006.005-.005.006.005Zm-.005-2.116-.006-.005.006-.005.005.005-.005.005ZM9.255 10.5v.008h-.008V10.5h.008Zm3.249 1.88-.007.004-.003-.007.006-.003.004.006Zm-1.38 5.126-.003-.006.006-.004.004.007-.006.003Zm.007-6.501-.003.006-.007-.003.004-.007.006.004Zm1.37 5.129-.007-.004.004-.006.006.003-.004.007Zm.504-1.877h-.008v-.007h.008v.007ZM9.255 18v.008h-.008V18h.008Zm-3.246-1.87-.007.004L6 16.127l.006-.003.004.006Zm1.366-5.119-.004-.006.006-.004.004.007-.006.003ZM7.38 17.5l-.003.006-.007-.003.004-.007.006.004Zm-1.376-5.116L6 12.38l.003-.007.007.004-.004.007Zm-.5 1.873h-.008v-.007h.008v.007ZM17.25 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Zm0 4.5a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
                                                    />
                                                </svg>
                                                <Link href={route('archive.index', { type: 'people' })}>
                                                    <h2 className="text-xl">ゲストコーナー「うみまちPeople」</h2>
                                                </Link>
                                            </li>

                                            <div className="pt-2 px-4">
                                                <Link href={route('archive.index', { type: 'people' })}>
                                                ゲストコーナー「うみまちPeople」では、うみまち地域に関わりながら活動を行う人々をゲストにお招きし、夢や人生のお話をお伺いします。
                                                </Link>

                                                <div className="mt-4 mb-4 flex justify-end">
                                                    <Link
                                                        href={route('archive.index', { type: 'people' })}
                                                        method="get"
                                                        as="button"
                                                        className="btn btn-outline btn-xs"
                                                    >
                                                        すべてを表示
                                                    </Link>
                                                </div>
                                            </div>

                                        </ul>

                                    </>
                                )}

                                {minkas.length > 0 && (
                                    <>
                                        <ul className="list border border-gray-700 bg-base-100 rounded-box mb-4 shadow-md">
                                            <li className="flex p-4 pb-1 text-base font-bold tracking-wide">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                    strokeWidth="1.5"
                                                    stroke="currentColor"
                                                    className="me-2 size-7"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="M12 18.75a6 6 0 0 0 6-6v-1.5m-6 7.5a6 6 0 0 1-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 0 1-3-3V4.5a3 3 0 1 1 6 0v8.25a3 3 0 0 1-3 3Z"
                                                    />
                                                </svg>
                                                <Link href={route('archive.index', { type: 'minka' })}>
                                                    <h2 className="text-xl">朗読「みんかみんかの民話」</h2>
                                                </Link>
                                            </li>

                                            <div className="pt-2 px-4">
                                                <Link href={route('archive.index', { type: 'minka' })}>
                                                朗読「みんかみんかの民話」は、川端美香さんが童話や各都道府県にまつわる民話朗読をお届けするコーナーです。
                                                </Link>

                                                <div className="mt-4 mb-4 flex justify-end">
                                                    <Link
                                                        href={route('archive.index', { type: 'minka' })}
                                                        method="get"
                                                        as="button"
                                                        className="btn btn-outline btn-xs"
                                                    >
                                                        すべてを表示
                                                    </Link>
                                                </div>
                                            </div>

                                        </ul>
                                    </>
                                )}

                                {minatos.length > 0 && (
                                    <>
                                        <ul className="list border border-gray-700 bg-base-100 rounded-box mb-4 shadow-md">
                                            <li className="flex p-4 pb-1 text-base font-bold tracking-wide">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                    strokeWidth="1.5"
                                                    stroke="currentColor"
                                                    className="me-2 size-7"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25"
                                                    />
                                                </svg>
                                                <Link href={route('archive.index', { type: 'minato' })}>
                                                    <h2 className="text-xl">出版社 港の人「ほんの1ページ」</h2>
                                                </Link>
                                            </li>

                                            <div className="pt-2 px-4">
                                                <Link href={route('archive.index', { type: 'minato' })}>
                                                鎌倉の出版社「港の人」より出版される本のご紹介と、ほんの少しの朗読を関根愛さんがお届けするコーナーです。
                                                </Link>

                                                <div className="mt-4 mb-4 flex justify-end">
                                                    <Link
                                                        href={route('archive.index', { type: 'minato' })}
                                                        method="get"
                                                        as="button"
                                                        className="btn btn-outline btn-xs"
                                                    >
                                                        すべてを表示
                                                    </Link>
                                                </div>
                                            </div>

                                        </ul>
                                    </>
                                )}

                                {akatsukis.length > 0 && (
                                    <>
                                        <ul className="list border border-gray-700 bg-base-100 rounded-box mb-4 shadow-md">
                                            <li className="flex p-4 pb-1 text-base font-bold tracking-wide">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                    strokeWidth="1.5"
                                                    stroke="currentColor"
                                                    className="me-2 size-7"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z"
                                                    />
                                                </svg>
                                                <Link href={route('archive.index', { type: 'akatsuki' })}>
                                                    <h2 className="text-xl">ラジオ劇「レッドムーンシアター」</h2>
                                                </Link>
                                            </li>

                                            <div className="pt-2 px-4">
                                                <Link href={route('archive.index', { type: 'akatsuki' })}>
                                                鎌倉の「紅月劇団」による選りすぐり場面を、劇団主催の石倉正英さんと劇団員の方々がラジオでお届けするコーナーです。
                                                </Link>

                                                <div className="mt-4 mb-4 flex justify-end">
                                                    <Link
                                                        href={route('archive.index', { type: 'akatsuki' })}
                                                        method="get"
                                                        as="button"
                                                        className="btn btn-outline btn-xs"
                                                    >
                                                        すべてを表示
                                                    </Link>
                                                </div>
                                            </div>

                                        </ul>
                                    </>
                                )}
                            </div>

                            <div>
                                <h3 className="py-4 text-2xl md:text-xl font-bold text-center md:text-left">うみまち掲示板</h3>
                                <ul className="list border border-gray-700 bg-base-100 rounded-box mb-4 shadow-md">
                                    <li className="flex p-4 pb-1 text-base font-bold tracking-wide">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            strokeWidth="1.5"
                                            stroke="currentColor"
                                            className="me-2 size-7"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M11.675 2.015a.998.998 0 0 0-.403.011C6.09 2.4 2 6.722 2 12c0 5.523 4.477 10 10 10 4.356 0 8.058-2.784 9.43-6.667a1 1 0 0 0-1.02-1.33c-.08.006-.105.005-.127.005h-.001l-.028-.002A5.227 5.227 0 0 0 20 14a8 8 0 0 1-8-8c0-.952.121-1.752.404-2.558a.996.996 0 0 0 .096-.428V3a1 1 0 0 0-.825-.985Z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                        <Link href={route('archive.index', { type: 'satomayo' })}>
                                            <h2 className="text-xl">佐藤麻陽の「月の小箱」</h2>
                                        </Link>
                                    </li>

                                    <div className="pt-2 px-4">
                                        <Link href={route('archive.index', { type: 'satomayo' })}>
                                        Moonlight Boxのラジオパーソナリティをつとめる佐藤麻陽さんがお届けするエッセイのコーナーです。
                                        </Link>

                                        <div className="mt-4 mb-4 flex justify-end">
                                            <Link
                                                href={route('archive.index', { type: 'satomayo' })}
                                                method="get"
                                                as="button"
                                                className="btn btn-outline btn-xs"
                                            >
                                                すべてを表示
                                            </Link>
                                        </div>
                                    </div>

                                </ul>

                                <h3 className="py-4 text-2xl md:text-xl font-bold text-center md:text-left">リンク</h3>
                                <ul className="list border border-gray-700 bg-base-100 rounded-box shadow-md">
                                    {extlinks.map((extlink) => {
                                        return (
                                            <li key={extlink.url} className="list-row">
                                                <div>
                                                    <div>
                                                        <a href={extlink.url} target="_blank" className="flex">
                                                            <img className="mb-2 max-h-8" src={extlink.logo} />
                                                            {extlink.text != null && <span className="ps-2 pt-1 text-lg"> {extlink.text}</span>}
                                                        </a>
                                                    </div>
                                                    <div className="text-xs font-semibold opacity-60">{extlink.name}</div>
                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>

                        <Footer />
                    </div>
                </div>
            </div>
        </>
    );
}
